import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Animated hero image: subtle continuous Ken-Burns drift + scroll parallax.
export const ParallaxHeroImage = ({ src, alt, children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);

  return (
    <div ref={ref} className="absolute inset-0 overflow-hidden">
      <motion.div style={{ y }} className="absolute -top-[10%] left-0 h-[130%] w-full">
        <motion.img
          src={src}
          alt={alt}
          className="h-full w-full object-cover"
          initial={{ opacity: 0, scale: 1.3 }}
          animate={{ opacity: 1, scale: [1.14, 1.24, 1.14] }}
          transition={{
            opacity: { duration: 1.3, ease: [0.22, 1, 0.36, 1] },
            scale: { duration: 22, repeat: Infinity, ease: "easeInOut" },
          }}
        />
      </motion.div>
      {children}
    </div>
  );
};
